const commitments = [
  {
    icon: 'ri-shield-star-line',
    title: 'Qualidade de Produtos',
    description: 'Oferecemos apenas produtos de marcas renomadas e com garantia oficial.',
  },
  {
    icon: 'ri-award-line',
    title: 'Produtos Originais',
    description: 'Toda nossa mercadoria é 100% original, com nota fiscal e garantia do fabricante.',
  },
  {
    icon: 'ri-customer-service-line',
    title: 'Suporte ao Cliente',
    description: 'Equipe especializada pronta para ajudar em todas as etapas da compra.',
  },
  {
    icon: 'ri-truck-line',
    title: 'Logística Eficiente',
    description: 'Entrega rápida e segura para todo o Brasil, com rastreamento em tempo real.',
  },
  {
    icon: 'ri-file-shield-line',
    title: 'Garantia e Segurança',
    description: 'Garantia em todos os produtos e processo de compra 100% seguro.',
  },
  {
    icon: 'ri-hand-heart-line',
    title: 'Compromisso Social',
    description: 'Atuamos com responsabilidade social e ambiental em todas as nossas operações.',
  },
];

export default function CommitmentsSection() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12">
          <h2 className="text-sm font-extrabold text-donnos-green uppercase tracking-wider mb-2">POR QUE ESCOLHER A DONNOS?</h2>
          <h3 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-gray-950">
            Compromisso com a excelência em tudo o que fazemos
          </h3>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12">
          {commitments.map((item) => (
            <article
              key={item.title}
              className="group rounded-xl px-5 py-6 text-center transition-all duration-300 ease-out hover:-translate-y-2 hover:bg-white hover:shadow-[0_18px_40px_rgba(15,23,42,0.10)]"
            >
              <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-donnos-green/10 transition-all duration-300 group-hover:scale-110 group-hover:bg-donnos-green group-hover:shadow-[0_14px_30px_rgba(0,200,83,0.22)]">
                <i className={`${item.icon} text-donnos-green text-2xl transition-all duration-300 group-hover:scale-110 group-hover:text-white`}></i>
              </div>
              <h4 className="mb-2 text-base font-extrabold text-gray-950 transition-colors duration-300 group-hover:text-donnos-green">{item.title}</h4>
              <p className="mx-auto max-w-md text-sm leading-relaxed text-slate-500 transition-colors duration-300 group-hover:text-slate-600">
                {item.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
